import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {
    getDateRangeOptionsForReport,
    getDateRangeLabel,
} from '../../../common/utils/dateRangeOptions';

import { getDateRange } from '../../../components/Reporting/applyFilters';

function formatShortDate(date) {
    if (!date) return '';

    return new Date(date).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}

function getDateRangeSummary(filters) {
    const [start, end] = getDateRange(filters);

    if (filters.dateRange === 'all') {
        return 'Includes all available records.';
    }

    if (filters.dateRange === 'custom') {
        if (!start && !end) return 'Choose a start and end date.';
        if (start && end) {
            return `Includes records from ${formatShortDate(start)} to ${formatShortDate(end)}.`;
        }
        return 'Choose a complete custom date range.';
    }

    if (!start || !end) return '';

    return `Includes records from ${formatShortDate(start)} to ${formatShortDate(end)}.`;
}

export default function DateRangeSelect({
    filters,
    setFilters,
    reportConfig = {},
    label = 'Date Range',
    showSummary = true,
    minWidth = 240,
}) {
    const dateRangeOptions = getDateRangeOptionsForReport(reportConfig);
    const selectedLabel = getDateRangeLabel(filters.dateRange, reportConfig);

    return (
        <Form.Group>
            {label ? <Form.Label>{label}</Form.Label> : null}

            <Form.Select
                value={filters.dateRange || ''}
                // style={{ minWidth }}
                size="sm"
                onChange={(e) => {
                    const nextDateRange = e.target.value;

                    setFilters((prev) => ({
                        ...prev,
                        dateRange: nextDateRange,
                    }));
                }}
            >
                {dateRangeOptions.map((group) => (
                    <optgroup key={group.label} label={group.label}>
                        {group.options.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </optgroup>
                ))}
            </Form.Select>
        </Form.Group>
    );
}